import { hFetch } from '@/lib/hfetch';
import type { AgentReferralEntity } from '@/api/entity_types/AgentReferral';

export type AgentReferralsListResponse = {
  referral_link: string | null;
  referrals: AgentReferralEntity[];
};

export type CreateAgentReferralPayload = {
  first_name: string;
  last_name: string;
  email: string;
  phone_number: string;
  license_status: 'licensed' | 'license_in_progress' | 'unlicensed';
  notes?: string;
};

export const listReferrals = async () => {
  return await hFetch<AgentReferralsListResponse>({
    url: '/api/agent/referrals',
  });
};

export const createReferral = async (payload: CreateAgentReferralPayload) => {
  return await hFetch<AgentReferralEntity, CreateAgentReferralPayload>({
    url: '/api/agent/referrals',
    method: 'POST',
    payload,
  });
};
